module.exports = __webpack_public_path__ + "media/images/carrusel/convenios-ed3d7d1a16f3c0976c4781db01cadeca.jpg";